import { useState } from 'react';
import { MobileFooterGeometry } from './mobileFooterGeometry';
import { MOBILE_NAVIGATION_MIN_HEIGHT } from './MobileNavigation';
import { Box, Container } from '@mui/material';
import { usePhoneLayout } from '../../hooks/usePhoneLayout';

export function AppShell({
  children,
  removeMargins = false,
  flushTop = false,
}: {
  children: React.ReactNode;
  removeMargins?: boolean;
  flushTop?: boolean;
}) {
  const phoneLayout = usePhoneLayout();
  const [navigationHeight, setNavigationHeight] = useState(
    MOBILE_NAVIGATION_MIN_HEIGHT,
  );
  return (
    <MobileFooterGeometry.Provider
      value={{ navigationHeight, setNavigationHeight }}
    >
      <Box
        sx={{
          minHeight: '100dvh',
          bgcolor: 'background.paper',
          '@supports not (height: 100dvh)': { minHeight: '100vh' },
          pb: phoneLayout ? 0 : 4,
        }}
      >
        <Container
          data-testid="app-content-container"
          maxWidth={false}
          sx={{
            maxWidth: removeMargins ? 'none' : 1640,
            px: {
              xs: 1.5,
              sm: removeMargins ? 1.5 : 3,
              lg: removeMargins ? 1.5 : 4,
            },
            pt: flushTop ? 0 : 'max(8px, env(safe-area-inset-top))',
          }}
        >
          {children}
        </Container>
      </Box>
    </MobileFooterGeometry.Provider>
  );
}
